/* import __COLOCATED_TEMPLATE__ from './conversation-sla-removed.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import type ConversationSlaRemoved from 'embercom/objects/inbox/renderable/conversation-sla-removed';
import LinkWithText from 'embercom/helpers/link-with-text';
import { createSafeAdminLink } from 'embercom/utils/admin-link';
import { truncateEventText, isEventTextTruncated } from 'embercom/lib/inbox2/event-text-truncation';

interface ConversationSlaRemovedPart extends RenderablePart {
  renderableData: ConversationSlaRemoved;
}

interface Args {
  part: ConversationSlaRemovedPart;
}

interface Signature {
  Args: Args;
}

export default class Inbox2ConversationStreamEventPartsConversationSlaRemovedComponent extends Component<Signature> {
  @service declare session: Session;

  // @ts-ignore helper doesn't seem to be typed correctly
  linkWithTextHelper = LinkWithText.create(this);

  get renderableData() {
    return this.args.part.renderableData;
  }

  get teammate() {
    return this.renderableData.adminSummary;
  }

  get slaLabel(): string {
    return this.renderableData.conversationSla.label;
  }

  get isSlaLabelTruncated(): boolean {
    return isEventTextTruncated(this.slaLabel);
  }

  get displaySlaLabel(): string {
    return truncateEventText(this.slaLabel);
  }

  get translationKey() {
    if (this.teammate.id === this.session.teammate.id) {
      return 'inbox.conversation-sla-removed.you-removed-sla-v2';
    } else {
      return 'inbox.conversation-sla-removed.admin-removed-sla-v2';
    }
  }

  get translationData() {
    if (this.teammate.id === this.session.teammate.id) {
      return {
        sla: this.displaySlaLabel,
      };
    } else {
      return {
        who: createSafeAdminLink(this.teammate, this.linkWithTextHelper),
        sla: this.displaySlaLabel,
      };
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::ConversationSlaRemoved': typeof Inbox2ConversationStreamEventPartsConversationSlaRemovedComponent;
    'inbox2/conversation-stream/event-parts/conversation-sla-removed': typeof Inbox2ConversationStreamEventPartsConversationSlaRemovedComponent;
  }
}
